// Kleine presentatie-componenten voor de project-status-weergave
// (ProjectMetaStrip, LastEntriesCard). Pure presentation.

// Twee woordenlijsten in één badge, want er zijn twee statussen in omloop: de
// activatiestatus die uit de retentieberekening komt en de projectstatus die
// een beheerder zelf zet (CompagnyMeta.Status). De sleutels overlappen niet,
// dus één lookup volstaat — maar een projectstatus die hier ontbrak kwam
// ongestileerd en in het Engels op het scherm ('active' in grijs).
const ACTIVATION_LABELS = {
    'not-activated': 'Niet geactiveerd',
    'in-onboarding': 'Onboarding',
    'in-transition': 'Transitie',
    'activated': 'Geactiveerd',
    'active': 'Actief',
    'inactive': 'Inactief',
    'archived': 'Gearchiveerd',
    'demo': 'Demo',
};

const ACTIVATION_CLASS = {
    'not-activated': 'retention-badge retention-badge--red',
    'in-onboarding': 'retention-badge retention-badge--yellow',
    'in-transition': 'retention-badge retention-badge--orange',
    'activated': 'retention-badge retention-badge--green',
    'active': 'retention-badge retention-badge--green',
    'inactive': 'retention-badge retention-badge--orange',
    'archived': 'retention-badge retention-badge--gray',
    'demo': 'retention-badge retention-badge--yellow',
};

const Spinner = () => (
    <span className="retention-spinner" aria-label="Laden" role="status" />
);

const ActivationBadge = ({ status, loading }) => {
    if (loading) return <Spinner />;
    if (!status) return <span className="retention-badge retention-badge--gray">—</span>;
    return (
        <span className={ACTIVATION_CLASS[status] || 'retention-badge retention-badge--gray'}>
            {ACTIVATION_LABELS[status] || status}
        </span>
    );
};

export { ActivationBadge, Spinner, ACTIVATION_LABELS };
